import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import MainHeadline from '../../atoms/MainHeadline';
import AuthStepOptions from '../../molecules/AuthStepOptions';
import WelcomeBack from '../../molecules/AuthStepOptions/WelcomeBack';
import { EmbeddedAuthBaseProps } from '../../organisms/EmbeddedAuth';
import ExpressCheckout from '../AuthStepOptions/ExpressCheckout';
import './style.scss';

type AuthFormProps = EmbeddedAuthBaseProps & {
  returningCustomer?: { firstName: string; lastName: string; email: string };
};

const AuthForm = ({ isEmbeddedAuth, returningCustomer }: AuthFormProps) => {
  const [isReturningCustomer, setIsReturningCustomer] = useState(!!returningCustomer);
  const { setFieldValue } = useFormikContext();

  return (
    <div className={classNames('form auth-form', { 'auth-form--embedded': isEmbeddedAuth })}>
      <MainHeadline>
        <FormattedMessage id={isEmbeddedAuth ? 'auth.embedded.headline' : 'auth.headline'} />
      </MainHeadline>
      {!isEmbeddedAuth && <ExpressCheckout />}
      {isReturningCustomer ? (
        <WelcomeBack
          returningCustomer={returningCustomer!}
          onDifferentCustomer={() => {
            setIsReturningCustomer(false);
            setFieldValue('email', '');
          }}
          isEmbeddedAuth={isEmbeddedAuth}
        />
      ) : (
        <AuthStepOptions isEmbeddedAuth={isEmbeddedAuth} />
      )}
    </div>
  );
};

export default AuthForm;
